export enum SidebarId {
    mainNabvbar = 'mainNabvbar',
    accountMenu = 'accountMenu',
    accountPageNav = 'accountPageNav',
    specialsTimeFilter = 'specialsTimeFilter',
    resultsPrimaryNav = 'resultsPrimaryNav',
    resultsSecondaryNav = 'resultsSecondaryNav',
    lottoPrimaryNav = 'lottoPrimaryNav',
    lottoTimeFilterSidebar = 'lottoTimeFilterSidebar',
    sportPrimaryNav = 'sportPrimaryNav',
    sportTimeFilter = 'sportTimeFilter',
    virtualGamesNav = 'virtualGamesNav',
    gamesNav = 'gamesNav',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/mobile/enums.ts